<div class="wrapper wrapper-full-page white-content">
  <app-progress-loader></app-progress-loader>
  <app-navbar></app-navbar>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>
